/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import _ from 'lodash';

import cleanUpResponse from '@/util/cleanUpResponse';
import { formatServerDate, formatServerDateTime, parseDisplayDate, parseDisplayDateTime } from '@/util/MomentUtils';

export default async function UpdateAWPackageInformationLegacy(formData) {
  const response = await $.soap({
    body: {
      UpdateAWPackageInformation: {
        $xmlns: 'http://dla.mil/ems/bpm/aw_package',
        AWPackage: {
          ID: formData.awPackageId,
          AWFDRNum: formData.awfdrNum,
          SubmittedOn: formatServerDateTime(parseDisplayDateTime(formData.submittedOn)),
          PIINSPIIN: formData.piinspiin,
          Vendor: formData.vendor,
          ContractStartDate: formatServerDate(parseDisplayDate(formData.contractStartDate)),
          ContractEndDate: formatServerDate(parseDisplayDate(formData.contractEndDate)),
          KOStatusDateReq: formatServerDate(parseDisplayDate(formData.koStatusDateReq)),
          FundingSourceID: formData.fundingSourceId
        },
        AWPackageContractExtensions: {
          AWPackageContractExtension: _.map(formData.awPackageContractExtensions, (contractExtension) => {
            return {
              ContractExtensionTypeID: contractExtension.contractExtensionTypeId,
              ExtensionEndDate: formatServerDate(parseDisplayDate(contractExtension.extensionEndDate)),
              PIINSPIIN: contractExtension.piinspiin,
              AWPackageContractExtensionFDRs: {
                AWPackageContractExtensionFDR: _.map(contractExtension.awPackageContractExtensionFdrs, (fdr) => {
                  return {
                    AWFDRNum: fdr.awfdrNum
                  };
                })
              }
            };
          })
        }
      }
    }
  });
  cleanUpResponse(response);
  return response;
}
